import { CrmContextPage } from 'pageModules/CrmContextPage/ui/CrmContextPage';

export default CrmContextPage;
